<template>
	<div>
		<div class="d-flex align-items-stretch">
			<div class="btn-amount-control decrease" :class="{disabled: count === 0}" @click="decreaseSpecCount(spec)">-</div>
			<input cy-input="item-count" class="text-center form-control" type="number" min="0" v-model="count" style="width: 64px"/>
			<div class="btn-amount-control increase" :class="{disabled: increaseButtonDisabled}" @click="increaseSpecCount(spec)">+</div>
		</div>
		<div v-if="increaseButtonDisabled" class="text-right"><small class="text-danger">{{$t('max_reached')}}</small></div>
		<div v-if="count > 1 && count == min" class="text-right"><small class="text-danger">{{$t('item.min_per_order_n', {n: count})}}</small></div>
		<div v-if="count != 0 && count == max" class="text-right"><small class="text-danger">{{$t('item.max_per_order_n', {n: count})}}</small></div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import RootStore from '../stores/root';

export default {
	props: {
		item: { required: true, type: Object },
		spec: { required: false, type: Object },
		groupAmountLeft: { required: false, type: Number }
	},
	store: RootStore,
	watch: {
		cartItems() {
			this.updateCount()
		},
		count() {
			if (this.max !== null && this.count > this.max) {
				this.count = this.max;
				return;
			}
			if (this.min !== null && this.count > 0 && this.count < this.min) {
				this.count = this.min;
				return;
			}
			if (this.count < 0) {
				this.count = 0;
				return;
			}
			this.$emit('count-changed', {item: this.item, spec: this.spec, count: this.count});
		}
	},
	mounted() {
		this.updateCount();
	},
	data() {
		return {
			count: 0
		}
	},
	computed: {
		...mapGetters({
			allCartItems: 'cart/items'
		}),
		cartItems() {
			return this.allCartItems.filter((item) => item.itemId || item.specId);
		},
		max() {
			return this.spec ? this.spec.max_per_order : this.item.max_per_order;
		},
		min() {
			return this.spec ? this.spec.min_per_order : this.item.min_per_order;
		},
		increaseButtonDisabled() {
			return this.count === this.max || (this.groupAmountLeft != null && this.groupAmountLeft == 0);
		}
	},
	methods: {
		increaseSpecCount() {
			if (this.increaseButtonDisabled) {
				return;
			}
			if (this.max !== null) {
				if (this.count < this.max) {
					this.count++;
					if (this.count < this.min) {
						this.count = this.min;
					}
				}
			} else {
				this.count++;
			}
		},
		decreaseSpecCount() {
			if (this.min !== null) {
				if (this.count > this.min) {
					this.count--;
				} else if (this.count <= this.min) {
					this.count = 0;
				}
			} else if (this.count > 0) {
				this.count--;
			}
		},
		updateCount() {
			var cartItem = null;
			if (this.spec) {
				cartItem = this.cartItems.find((cartItem) => cartItem.specId == this.spec.id)
			} else {
				cartItem = this.cartItems.find((cartItem) => cartItem.itemId == this.item.id)
			}
			if (cartItem) {
				this.count = cartItem.count;
			}
		}
	}
}
</script>

<i18n>
{
	"zh": {
		"ge": "個"
	},
	"en": {
		"ge": "Item|Items"
	}
}
</i18n>

<style lang="scss" scoped>

input {
	border-radius: 0;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
	/* display: none; <- Crashes Chrome on hover */
	-webkit-appearance: none;
	margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
	-moz-appearance:textfield; /* Firefox */
}

.btn-amount-control {
	display: flex;
	align-items: center;
	font-weight: bold;
	width: 32px;
	flex-shrink: 0;
	text-align: center;
	border: 1px solid #DDDDDD;
	border-radius: 6px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	justify-content: center;

	&:hover {
		background: #f0f0f0;
		cursor: pointer;
	}

	&:active {
		background: #E0e0e0;
	}

	&.decrease {
		border-right: none !important;
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
	}
	&.increase {
		border-left: none !important;
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
	}

	&.disabled, &.disabled:hover, &.disabled:active {
		opacity: 0.5;
		cursor:not-allowed;
		background: white;
	}

}
</style>

<i18n>
	{
		"zh": {
			"max_reached": "已達上限"
		},
		"en": {
			"max_reached": "Max reached"
		}
	}
</i18n>